import { memo } from 'react';
import { View } from '@picsart/view';
import { Texts } from '@picsart/cascade';
import IconPlusLarge from '@picsart/icons/IconPlusLarge';
import { useTranslator } from '@picsart/rc/services/localization';
import { FileRejection } from 'react-dropzone';

import useFileUploader from 'hooks/useFileUploader';

import useStyles from './styles';
import testIds from './testId';

export interface UploadButtonProps {
  onClick?: () => void;
  onCancel?: () => void;
  onSelect: (files: File[], rejectedFiles: FileRejection[]) => void;
  isOpen?: boolean;
  allowMultiple?: boolean;
  maxCount?: number;
  title: string;
  text?: string;
  useIcon?: boolean;
}

function UploadButton({
  text,
  title,
  onSelect,
  maxCount = 0,
  isOpen = true,
  useIcon = true,
  allowMultiple = true,
}: UploadButtonProps) {
  const classes = useStyles();
  const translate = useTranslator();
  const { inputProps, handleUploadClick } = useFileUploader({
    onFileUploadDone: onSelect,
    multiple: allowMultiple,
    maxCount,
  });

  return (
    <>
      <div onClick={handleUploadClick} className={classes.uploader} data-testid={testIds.uploadButtonWrapper}>
        {useIcon && (
          <View>
            <IconPlusLarge data-testid={testIds.uploadButtonIcon} fill={Texts.base} cursor="pointer" />
          </View>
        )}
        {title && <div className={classes.uploaderTitle} data-testid={testIds.uploadButtonTitle}>{translate(title)}</div>}
      </div>
      {text && <div className={classes.uploaderText} data-testid={testIds.uploadButtonText}>{translate(text)}</div>}
      <input
        {...inputProps}
        className={classes.inputFile}
        disabled={!isOpen}
        data-testid={testIds.uploadButtonInput}
      />
    </>
  );
}

export default memo(UploadButton);
